export enum dashboardHLTypes {
    GET_TOKEN_IFRAME = '@@dashboard/GET_TOKEN_IFRAME',
    GET_GENERIC_TOKEN_IFRAME = '@@dashboard/GET_GENERIC_TOKEN_IFRAME',
    GET_TOKEN_IFRAME_SUCCESS = '@@dashboard/GET_TOKEN_IFRAME_SUCCESS',
    GET_TOKEN_IFRAME_FAIL = '@@dashboard/GET_TOKEN_IFRAME_FAIL',
  
  }
  